import { FC } from "react";
import { Props } from "./types";
import { helpers } from "../../helpers";
import AnswerRenderer from "../AnswerRenderer";
import { Typography } from "antd";
import SafeMarkdown from "../SafeMarkdown";
import {
  StyledAnswerContainer,
  StyledCodeExplanation,
  StyledLimitationWarning,
  StyledModifiedQuery,
  StyledQueryFileName,
  StyledWorkerStepStatus,
} from "./index.styles";
import { createPortal } from "react-dom";
import { SUGGESTION_CLICK_EVENT, STILL_WORKING_MESSAGE, WORKER_STEP_LABELS } from "../../constants";

const Answer: FC<Props> = ({ item, container }) => {
  const onSuggestionClick = (suggestion: string) => {
    container.host.dispatchEvent(
      new CustomEvent(SUGGESTION_CLICK_EVENT, {
        detail: { suggestion },
        bubbles: true,
        composed: true,
      })
    );
  };

  return createPortal(
    <StyledAnswerContainer>
      {!!item.modifiedQuery && (
        <StyledModifiedQuery className="modified-query">
          Bu soruyu şu şekilde anladım: <i>{item.modifiedQuery}</i>
        </StyledModifiedQuery>
      )}
      {!!item.fileName && (
        <StyledQueryFileName className="query-file-name">
          Dosya adı: <i>{item.fileName}</i>
        </StyledQueryFileName>
      )}
      {!!item.dataLimitationWarning && (
        <StyledLimitationWarning className="limitation-warning">
          Uyarı: <i>{item.dataLimitationWarning}</i>
        </StyledLimitationWarning>
      )}
      {!!item.codeExplanation && (
        <StyledCodeExplanation className="code-explanation">
          <SafeMarkdown markdown={item.codeExplanation} />
        </StyledCodeExplanation>
      )}
      <AnswerRenderer
        inProgress={item.inProgress}
        answer={item.answer}
        resultType={item.resultType}
        resultStatus={item.resultStatus}
        shouldRenderSuggestions
        suggestions={item.suggestions}
        imageStoreBaseUrl={item.imageStoreBaseUrl}
        onSuggestionClick={onSuggestionClick}
      />
      {item.inProgress && (
        <StyledWorkerStepStatus className="worker-step-status">
          {item.currentWorkerStep
            ? WORKER_STEP_LABELS[item.currentWorkerStep] || STILL_WORKING_MESSAGE
            : STILL_WORKING_MESSAGE}
        </StyledWorkerStepStatus>
      )}
      {!item.inProgress && (
        <div className="item-footer">
          {!!item.createAt && (
            <div>
              <Typography className="created-at">
                {helpers.formatDateTime(`${item.createAt}`)}
              </Typography>
            </div>
          )}
        </div>
      )}
    </StyledAnswerContainer>,
    container
  );
};

export default Answer;
